import {
    PAGE_ADD_API_RESPONSE,
    PAGE_ADD_CODE,
    PAGE_ADD_GAME_ANSWER,
    PAGE_ADD_USER_ANSWER,
    PAGE_NEXT_STEP,
    PAGE_SHOW_NEXT,
    PAGE_SHOW_NO_INVESTORS,
    PAGE_SHOW_OTHER,
    RESTORE_PROGRESS,
    SUCCESS,
} from "@/constants";
import {getResponseIdFromSearch, saveProgress} from "@/utils/progressStorage";

const NAVIGATION_ACTIONS = new Set([
    PAGE_SHOW_NEXT,
    PAGE_SHOW_OTHER,
    PAGE_SHOW_NO_INVESTORS,
    PAGE_NEXT_STEP,
    PAGE_ADD_USER_ANSWER + SUCCESS,
    PAGE_ADD_GAME_ANSWER + SUCCESS,
    PAGE_ADD_CODE + SUCCESS,
    PAGE_ADD_API_RESPONSE + SUCCESS,
]);

const progressMiddleware = store => next => action => {
    const result = next(action);

    if (action.type !== RESTORE_PROGRESS && NAVIGATION_ACTIONS.has(action.type)) {
        const responseId = getResponseIdFromSearch();
        saveProgress(responseId, store.getState().pageReducer, true);
    }

    return result;
};

export default progressMiddleware;
